import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import classnames from 'classnames';
import { color } from '../../app/theme';
import config from '../../app/config';
import Button from './Button';

const useStyles = makeStyles(
  {
    root: {
      padding: '24px',
      border: `1px solid ${color.$10}`,
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },
    title: {
      fontSize: '15px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      color: color.$13,
      marginBottom: 16,
      textAlign: 'center',
    },
    subtitle: {
      fontWeight: '400',
      fontSize: '13px',
      lineHeight: '18px',
      color: color.$13,
      marginBottom: 36,
    },
    logoImageUrl: {
      width: 80,
      height: 80,
      margin: '0 auto 16px',
    },
    hr: {
      width: '100%',
      height: '1px',
      borderTopColor: color.$9,
      margin: '12px 0',
    },
    name: {
      fontWeight: '400',
      fontSize: '17px',
      lineHeight: '17px',
      color: color.$3,
      marginBottom: 4,
    },
    email: {
      fontWeight: '400',
      fontSize: '13px',
      lineHeight: '19px',
      color: color.$12,
      display: '-webkit-box',
      overflow: 'hidden',
      wordBreak: 'break-all',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: '1',
    },
    row: {
      textAlign: 'left',
      marginLeft: '6px',
    },
    option: {
      width: '100%',
      padding: '0px 12px',
      marginRight: '0',
    },
    isBind: {
      fontWeight: '400',
      fontSize: '13px',
      lineHeight: '13px',
      color: color.$18,
      backgroundColor: '#f1c03633',
      padding: '6px 8px',
      borderRadius: 12,
      minWidth: 58,
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    isBindTextColor: {
      color: color.$10,
    },
  },
  {
    name: 'SearchCustomersPage',
  },
);

const SearchCustomersPage = ({
  data,
  customers = [],
  isLoading,
  onBind = () => {},
  onPrevPage = () => {},
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [customer, setCustomer] = useState(null);
  const { bindPage } = data || {};
  const { logoImageUrl } = bindPage || {};

  useEffect(() => {
    const notBindCustomers = customers.filter(c => !c?.isBind);
    if (notBindCustomers && notBindCustomers.length) {
      setCustomer(notBindCustomers?.[0]);
    }
  }, [customers]);

  return (
    <div className={classes.root}>
      <div className={classes.title}>{t('ecBinding:choseCustomer')}</div>
      <img
        className={classes.logoImageUrl}
        src={logoImageUrl || config.DEFAULT_LOGO_IMAGE_URL}
        alt="logoImageUrl"
      />
      <div className={classes.subtitle}>
        {t('ecBinding:choseCustomerSubtitle')}
      </div>
      <FormControl component="fieldset">
        <RadioGroup
          aria-label="default-display"
          name="default-display"
          value={customer?.id || ''}
          onChange={e => {
            const id = e.target.value;
            setCustomer(
              customers.find(c => c?.id?.toString() === id.toString()),
            );
          }}
        >
          {customers.map(c => {
            return (
              <div key={`FormControlLabel-${c?.id}`}>
                <FormControlLabel
                  disabled={c?.isBind}
                  className={classes.option}
                  value={c?.id}
                  control={<Radio color="primary" />}
                  label={
                    <div className={classes.label}>
                      <div className={classes.row}>
                        <div
                          className={classnames(classes.name, {
                            [classes.isBindTextColor]: c?.isBind,
                          })}
                        >
                          {c?.name}
                        </div>
                        <div
                          className={classnames(classes.email, {
                            [classes.isBindTextColor]: c?.isBind,
                          })}
                        >
                          {c?.email}
                        </div>
                      </div>
                      {c?.isBind ? (
                        <div className={classes.isBind}>
                          {t('ecBinding:isBind')}
                        </div>
                      ) : (
                        <div />
                      )}
                    </div>
                  }
                />
                <hr className={classes.hr} />
              </div>
            );
          })}
        </RadioGroup>
      </FormControl>
      <Button
        style={{ marginTop: 30 }}
        topic="primaryGreen"
        isLoading={isLoading}
        isDisable={!customer}
        onClick={() => onBind(customer)}
      >
        {t('ecBinding:choseCustomerBtn')}
      </Button>
      <Button
        style={{ marginTop: 24 }}
        topic="primaryBlue"
        isLoading={isLoading}
        onClick={onPrevPage}
      >
        {t('ecBinding:prevPage')}
      </Button>
    </div>
  );
};

export default SearchCustomersPage;
